import FavouritesInfoCard from "@common/components/ResidenceGeneric/FavouritesInfoCard";
import ImageDisplayCompare from "@common/components/ResidenceGeneric/ImageDisplayCompare";
import { useStore } from "@state/store";
import styled from "styled-components";
import { TrashIcon } from "@radix-ui/react-icons";
import TextButton from "@common/ui/TextButton";
import { useFavoritesStore } from "@state/favouritesStore";
import Modal from "@common/ui/Modal";
import { useState } from "react";
import ResidenceInfoCard from "@common/components/ResidenceGeneric/ResidenceInfoCard";
import FloorplanImage from "@common/components/ResidenceGeneric/FloorplanImage";

type UnitCompareProps = {
  sections: any[];
  contentControls: any;
  selectedRows: any[];
  className?: string;
};

const UnitCompare = (props: UnitCompareProps) => {
  const { className, selectedRows } = props;
  const { removeFromFavorites } = useFavoritesStore();
  const syncState = useStore((s) => s.syncState);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [leftUnitIndex, setLeftUnitIndex] = useState(1);
  const [leftUnitPopup, setLeftUnitPopup] = useState(false);
  const [rightUnitIndex, setRightUnitIndex] = useState(0);
  const [rightUnitPopup, setRightUnitPopup] = useState(false);

  const handleModalOpen = (open: boolean, selectedUnit: any) => {
    setIsModalOpen(open);
    setSelectedUnit(selectedUnit);
  };

  return (
    <Wrapper
      className={className}
      contentControls={props?.contentControls?.index}
    >
      <div className="unit-top">
        {selectedRows[leftUnitIndex]
          ? (
            <>
              <div className="card">
                <TextButton
                  onClick={() =>
                    handleModalOpen(true, selectedRows[leftUnitIndex])}
                  variant="fill"
                  color="primary"
                  className="imageOverlayToggleFav"
                  icon={
                    <img
                      src="assets/icons/enlarge.png"
                      alt=""
                      style={{ filter: "invert(100%)" }}
                    />
                  }
                />
                <TextButton
                  onClick={() => setLeftUnitPopup(true)}
                  variant="fill"
                  color="primary"
                  className="listOverlayToggleFav"
                >
                  Change Unit
                </TextButton>
                <FloorplanImage unit={[selectedRows[leftUnitIndex]]} />
                {leftUnitPopup && (
                  <List>
                    {selectedRows.map((obj, i) => {
                      return (
                        <TextButton
                          onClick={() => {
                            setLeftUnitIndex(i);
                            setTimeout(() => {
                              setLeftUnitPopup(false);
                            }, 300);
                          }}
                          variant="fill"
                          color="primary"
                          className="unit-select"
                          style={{
                            opacity: i === leftUnitIndex ? 0.5 : 1,
                          }}
                          key={obj.unitName}
                        >
                          Apartment {obj.unitName}
                        </TextButton>
                      );
                    })}
                    <TextButton
                      onClick={() => setLeftUnitPopup(false)}
                      variant="fill"
                      color="primary"
                      className="unit-select close"
                    >
                      Close
                    </TextButton>
                  </List>
                )}
              </div>
            </>
          )
          : (
            <div className="no-compare">
              Click an apartment<span>to compare</span>
            </div>
          )}
      </div>
      <div className="unit-bottom">
        {selectedRows[rightUnitIndex]
          ? (
            <>
              <div className="card">
                <TextButton
                  className="imageOverlayToggleFav"
                  onClick={() =>
                    handleModalOpen(true, selectedRows[rightUnitIndex])}
                  variant="fill"
                  color="primary"
                  icon={
                    <img
                      src="assets/icons/enlarge.png"
                      alt=""
                      style={{ filter: "invert(100%)" }}
                    />
                  }
                />
                <TextButton
                  onClick={() => setRightUnitPopup(true)}
                  variant="fill"
                  color="primary"
                  className="listOverlayToggleFav"
                >
                  Change Unit
                </TextButton>
                <FloorplanImage unit={[selectedRows[rightUnitIndex]]} />
                {rightUnitPopup && (
                  <List>
                    {selectedRows.map((obj, i) => {
                      return (
                        <TextButton
                          onClick={() => {
                            setRightUnitIndex(i);
                            setTimeout(() => {
                              setRightUnitPopup(false);
                            }, 300);
                          }}
                          variant="fill"
                          color="primary"
                          className="unit-select"
                          style={{
                            opacity: i === rightUnitIndex ? 0.5 : 1,
                          }}
                          key={obj.unitName}
                        >
                          Apartment {obj.unitName}
                        </TextButton>
                      );
                    })}
                    <TextButton
                      onClick={() => setRightUnitPopup(false)}
                      variant="fill"
                      color="primary"
                      className="unit-select close"
                    >
                      Close
                    </TextButton>
                  </List>
                )}
              </div>
            </>
          )
          : (
            <div className="no-compare">
              Click an apartment<span>to compare</span>
            </div>
          )}
      </div>
      <Modal
        style={{
          backgroundColor: "var(--primary)",
          height: "90%",
          width: "90%",
          overflow: "hidden",
        }}
        isFullScreen={false}
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <ImageDisplayCompare
          show={setIsModalOpen}
          selectedUnit={selectedUnit}
        />
      </Modal>
    </Wrapper>
  );
};

export default UnitCompare;

const Wrapper = styled.div<{ contentControls }>`
  display: flex;
  justify-content: column;
  position: relative;
  background-color: #ffffff1e;

  .button {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    z-index: 10;
    transform-origin: bottom right;
    border: none;
    background-color: transparent;
    height: 5em;
    width: 5em;
  }

  .line {
    width: 90%;
    height: 1px;
    position: absolute;
    background-color: var(--accent);
  }

  .unit-top,
  .unit-bottom {
    width: 100%;
    max-height: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: ${({ contentControls }) =>
  contentControls === 1 ? "" : "2rem"}; */

    .card {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
    }

    .no-compare {
      display: flex;
      flex-direction: column;
      text-transform: uppercase;
      color: var(--secondary);
      font-size: 1.5em;
      letter-spacing: 0.2em;
      line-height: 0.9;

      span {
        font-size: 0.8em;
        color: var(--accent);
        text-transform: lowercase;
        font-family: secondaryFont;
        text-align: right;
        margin-right: -2em;
        font-size: 2em;
      }
    }
  }

  .imageOverlayToggleFav {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 2rem;
    padding: 0.25rem;
    border-radius: 5px;
    aspect-ratio: 1/1;
    background-color: var(--secondary);
    transform: scale(0.75);
    transform-origin: bottom right;
    z-index: 10;
  }
  .listOverlayToggleFav {
    position: absolute;
    bottom: 0;
    right: 4rem;
    margin: 2rem;
    padding: 0.25rem;
    border-radius: 5px;
    background-color: var(--secondary);
    color: white;
    transform: scale(0.75);
    transform-origin: bottom right;
    z-index: 10;
    width: 15% !important;
  }
`;

const List = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  pointer-events: all;
  overflow-y: scroll;
  gap: 2rem;
  padding: 7rem 0;

  .unit-select {
    padding: 0.25rem;
    border-radius: 5px;
    background-color: var(--secondary);
    color: white;
    font-family: SecondaryFont;
    width: 20% !important;
    min-height: 3rem;
  }

  .close {
    bottom: 2rem;
    right: 1rem;
    width: 15% !important;
  }
`;
